import { Image as SiteImage, RichText, OptionalSiteLinkWrapper, Swiper } from 'components/shared';
import renderLines from 'components/shared/renderLines';
import { useUI } from 'hooks';
import richTextOptions from './articles/richTextOptions';
import validateRequired from './validate-required';
import withPropValidation from './with-props-validation.tsx';

const Section = ({ data: { article, showArticleOnLeft, bannersCollection } }) => {
  const { isDesktop } = useUI();
  const banners = bannersCollection?.items?.map(item => {
    const { image, mobileImage, title, subtitle, link, fullWidth } = item || {};
    const imageValue = isDesktop ? image || mobileImage : mobileImage || image;
    return (
      <div
        className={`relative h-[395px] md:flex-1 
      ${fullWidth ? 'md:min-w-[100%]' : 'md:min-w-[50%]'} 
      ${fullWidth ? 'md:h-[452px]' : 'md:h-[536px]'} 
      `}
        key={imageValue?.url}
      >
        <OptionalSiteLinkWrapper link={link} event="Season preview clicked">
          {imageValue && (
            <SiteImage
              src={imageValue}
              className="absolute h-full w-full md:border-[7px] md:border-white"
            />
          )}
          {title && (
            <div className="absolute bottom-[45px] w-full text-center text-white">
              {subtitle && (
                <div className="nimbus-sans-d-regular text-center text-[15px] capitalize">
                  {subtitle}
                </div>
              )}
              <h2 className="w-full text-center font-nimbus-sans-extd-d text-[25px] font-bold uppercase leading-[21.25px]">
                {title}
              </h2>
            </div>
          )}
        </OptionalSiteLinkWrapper>
      </div>
    );
  });

  return (
    <div
      className={`relative flex w-full flex-col antialiased md:min-h-screen md:flex-row md:p-[60px] md:pt-[38px]
      ${!showArticleOnLeft && ' md:flex-row-reverse'}
      `}
    >
      <div
        className={`flex-1 text-center text-blue md:text-left
        ${!showArticleOnLeft && ' md:ml-[116px]'}
        `}
      >
        <div className="flex items-center justify-center md:sticky md:top-[0px] md:h-[100vh]">
          <div>
            <h1 className="mt-[60px] font-nimbus-sans-extd-d text-[30px] font-bold uppercase leading-[90%] md:mt-[120px]">
              {renderLines(article.title)}
            </h1>
            <div className="m-auto mb-[55px] mt-[12px] w-[70%] font-nimbus-sans-d text-[15px] leading-[140%] md:mb-0 md:ml-0 md:mt-[25px]">
              <RichText data={article.article} options={richTextOptions(article.article)} />
            </div>
          </div>
        </div>
      </div>
      <div className="flex-2 hidden min-w-[66%] flex-wrap overflow-hidden md:flex">{banners}</div>
      <Swiper className="relative mb-[55px] w-full md:hidden" slidesPerView={1.2}>
        {banners.map((banner, idx) => {
          const item = bannersCollection.items[idx];
          const key =
            (isDesktop ? item?.image || item?.mobileImage : item?.mobileImage || item?.image)?.id ||
            `banner-slide-${idx}`;
          return <div key={key}>{banner}</div>;
        })}
      </Swiper>
    </div>
  );
};

export default withPropValidation(Section, ({ data: { name, article } }) => [
  ...validateRequired({
    Name: name,
    Article: article,
  }),
]);
